"use client";

import { Button } from "app/_components/components/Button";
import { Body } from "app/_components/components/Text/Body";
import Link from "next/link";
import { useExperiment } from "app/_optimizely-features/useExperiment";
import {
  OPTIMIZELY_FEATURE_FLAGS,
  OPTIMIZELY_FEATURE_VARIABLES
} from "analytics/optimizely/config/constants";

const STATUS_PAGE_URL = "https://status.gemini.com";
const EXPERIMENT_KEY = "service_outage_banner_experiment";
const DEFAULT_MESSAGE =
  "We're currently experiencing issues with some services. We're working to resolve them as quickly as possible.";

interface ServiceOutageVariables extends Record<string, unknown> {
  [OPTIMIZELY_FEATURE_VARIABLES.SERVICE_OUTAGE_MESSAGE]?: string;
}

export function ServiceOutageBanner() {
  const { enabled, loading, variables } = useExperiment<ServiceOutageVariables>(
    OPTIMIZELY_FEATURE_FLAGS.SERVICE_OUTAGE_BANNER,
    EXPERIMENT_KEY
  );

  if (loading || !enabled) {
    return null;
  }

  const message =
    variables[OPTIMIZELY_FEATURE_VARIABLES.SERVICE_OUTAGE_MESSAGE] ||
    DEFAULT_MESSAGE;

  return (
    <div className="flex flex-grow flex-wrap items-center justify-center gap-4 border-b border-[hsl(48,89%,70%)] bg-[hsl(48,89%,70%)] px-4 py-4">
      <div className="flex items-center gap-2">
        <Body size="sm" bold className="text-center">
          {message}
        </Body>
      </div>

      <div className="flex flex-wrap justify-center gap-2">
        <Button size="sm" asChild variant="secondary">
          <Link
            href={STATUS_PAGE_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Status Page
          </Link>
        </Button>
      </div>
    </div>
  );
}
